import { useState } from "react";
import { accommodations, areas } from "@/mocks/accommodations";
import AccommodationCard from "./AccommodationCard";

export default function Best15Section() {
  const [activeArea, setActiveArea] = useState("전체");

  const filtered =
    activeArea === "전체"
      ? accommodations
      : accommodations.filter((a) => a.area === activeArea);

  return (
    <section id="best15" className="py-12 sm:py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="mb-8 sm:mb-10">
          <div className="inline-flex items-center gap-2 text-amber-600 text-xs font-semibold tracking-widest uppercase mb-3">
            <i className="ri-building-2-line"></i>
            BEST 15 COLLECTION
          </div>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-3">
            <div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-stone-800 mb-2">
                한국인 호스트<br className="md:hidden" /> 엄선 숙소
              </h2>
              <p className="text-stone-500 text-sm max-w-lg leading-relaxed">
                후쿠오카 전 지역에서 한국어 소통, 친절한 현지 가이드, 청결도까지
                직접 검증한 15개의 숙소를 만나보세요.
              </p>
            </div>
            <div className="text-stone-400 text-sm">
              총 <strong className="text-amber-500">{filtered.length}곳</strong> 표시 중
            </div>
          </div>
        </div>

        {/* Area Filter - 모바일 가로 스크롤 */}
        <div className="flex gap-2 mb-6 sm:mb-8 overflow-x-auto pb-2 scrollbar-none -mx-4 px-4 sm:mx-0 sm:px-0 sm:flex-wrap">
          {areas.map((area) => (
            <button
              key={area}
              onClick={() => setActiveArea(area)}
              className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap flex-shrink-0 ${
                activeArea === area
                  ? "bg-amber-500 text-white"
                  : "bg-white text-stone-600 border border-stone-200 hover:border-amber-400 hover:text-amber-600"
              }`}
            >
              {area}
            </button>
          ))}
        </div>

        {/* Grid - 모바일 1열, 태블릿 2열, 데스크탑 3~4열 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-5">
          {filtered.map((item, idx) => (
            <AccommodationCard key={item.id} item={item} index={idx} />
          ))}
        </div>

        {filtered.length === 0 && (
          <div className="text-center py-16 text-stone-400">
            해당 지역의 숙소가 없습니다.
          </div>
        )}
      </div>
    </section>
  );
}
